module.exports = __webpack_public_path__ + "static/img/appStoreGif.fa45d78.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/appStoreGif.gif
// module id = 5zcP
// module chunks = 2